import { useSelector } from 'react-redux'
import {
  useGetPointsQuery,
  useGetStopsQuery,
  useGetTrailsByIdQuery,
} from 'Services/institution'

type Point = {
  stopid: number | null
  [key: string]: any
}

type FilteredResult = {
  stopPoints: Point[]
  nextStop: Point | null
  currentStop: any
}

export const getWalkingPoints = (stopId: number) => {
  const { locId, instId, tourId, instName } = useSelector(
    (state: any) => state.location
  )

  /* Stops */
  const { data: tourStopsData } = useGetStopsQuery({
    instId,
    locId,
  })

  const stops =
    Object.values(tourStopsData?.resources || {}).length > 1
      ? (
          Object.values(tourStopsData?.resources || {}).find(
            (tour: any) => tour.tour_name === instName
          ) as { stops: Array<any> } | undefined
        )?.stops
      : (
          Object.values(tourStopsData?.resources || [])[0] as {
            stops: Array<any>
          }
        )?.stops

  /* Points */
  const { data: { resources: pointsData = [] } = {} } = useGetPointsQuery(
    {
      instId,
      locId,
      tourId,
    },
    { skip: !locId || !instId || !tourId }
  )

  /* Points */
  const { data: { resources: trailsD = [] } = {} } = useGetPointsQuery(
    {
      instId,
      locId,
      tourId,
    },
    { skip: !locId || !instId || !tourId }
  )

  const trailId = pointsData?.data?.find(
    (point) => point.stopid === stopId
  )?.trailid

  /* Trails */
  const { data: { resources: trailsData = [] } = {} } = useGetTrailsByIdQuery(
    {
      instId,
      locId,
      tourId,
      trailId,
    },
    { skip: !locId || !instId || !tourId || !trailId }
  )

  const getFilteredPoints = (
    points: Point[],
    stopId: number
  ): FilteredResult => {
    const filteredPoints: Point[] = []
    let nextStop: Point | null = null
    let currentStop: any = null
    let foundInitialStop = false

    for (const point of points) {
      if (!foundInitialStop) {
        if (point.stopid === stopId) {
          foundInitialStop = true
        }
        continue
      }

      if (point.stopid !== null) {
        nextStop = stops?.find((stop) => stop.stopid === point.stopid)
        currentStop = stops?.find((stop) => stop.stopid === stopId)
        break
      }

      filteredPoints.push(point)
    }

    return { stopPoints: filteredPoints, nextStop, currentStop }
  }

  const walkingPoints =
    trailsData && trailsData.trail && trailsData.trail.points
      ? getFilteredPoints(trailsData.trail.points, stopId)
      : { stopPoints: [], nextStop: null }

  return {
    walkingPoints,
  }
}
